// extracted by mini-css-extract-plugin
export default {"divContenido":"Graficos_divContenido__bo5bR","button":"Graficos_button__Fqluh","btn_active":"Graficos_btn_active__tOp8V"};